//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { fetchAll, destroy, _STATUS, _ADTYPE, _POSITION } from '@/apis/advertisement'
import moment from 'moment';

export default {
    data() {
        return {
            config: {
                //運動類型
                status: [],
                position: [],
                adType: [],
            },
            searchQuery: {
                status: '',
                displayPosition: '',
                adType: '',
                adName: "",
            },
            previewVisible: false,
            previewImage: "",
            //table loading
            loading: false,
            //table data
            records: [],
            //table columns
            columns: [],
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0
            }
        }
    },
    created() {
        this.columns = [
            { title: '名稱', dataIndex: 'adName', key: 'adName', width: 330, },
            { title: '內容圖片', key: 'imageUrl', width: 200, scopedSlots: { customRender: 'imageSlot' }, },
            { title: '類型', dataIndex: 'adTypeText', key: 'adType', width: 200, },
            { title: '渲染位置', dataIndex: 'displayPositionText', key: 'displayPosition', width: 200, },
            { title: '排序編碼', dataIndex: 'sortOrder', key: 'sortOrder', width: 200, },
            { title: '狀態', key: 'status', width: 100, scopedSlots: { customRender: 'statusSlot' }, },
            { title: '創建時間', dataIndex: 'createdTime', key: 'createdTime', width: 180, },
            { title: '操作', key: 'operation', minWidth: 330, scopedSlots: { customRender: 'action' }, }
        ];
    },
    mounted() {
        this.$nextTick(async () => {
            await this.onPageConfig();
            await this.onPageLoad();
        });
    },
    methods: {
        handleCancel() {
            this.previewVisible = false;
        },
        async handlePreview(url) {
            this.previewImage = url;
            this.previewVisible = true;
        },
        async onPageConfig() {
            try {
                let _status = [], _position = [], _adtype = [];

                Object.keys(_STATUS).forEach(value => {
                    _status.push({
                        id: value,
                        name: _STATUS[value]
                    })
                });
                this.config.status = _status;

                Object.keys(_ADTYPE).forEach(value => {
                    _adtype.push({
                        id: value,
                        name: _ADTYPE[value]
                    })
                });
                this.config.adType = _adtype;

                Object.keys(_POSITION).forEach(value => {
                    _position.push({
                        id: value,
                        name: _POSITION[value]
                    })
                });
                this.config.position = _position;

            } catch (error) {
                this.$message.error(error.message);
            }
        },
        async onPageLoad(isPostBack) {
            const _this = this;

            if (this.loading) return;
            if (!isPostBack) {
                
                this.pagination.current = 1;
            }
            try {
                this.loading = true;
                const res = await fetchAll({
                    ...this.searchQuery,
                    pageNumber: this.pagination.current,
                    pageSize: this.pagination.pageSize
                });
                res.data.records.forEach(value => {
                    let adType = _this.config.adType.filter(item => item.id == value.adType)
                    value.adTypeText = adType[0] !== undefined ? adType[0].name : '';
                    let displayPosition = _this.config.position.filter(item => item.id == value.displayPosition)
                    value.displayPositionText = displayPosition[0] !== undefined ? displayPosition[0].name : '';
                });
                console.log(`output->res.data.records`,res.data.records)
                this.records = res.data.records;
                this.pagination.total = res.data.total;
            } catch (error) {
                this.$message.error(error.message);
            } finally {
                this.loading = false;
            }
        },
        //獲取運動類型名稱
        getSportTypeName(code) {
            if (code && this.config.motions) {
                const data = this.config.motions.filter(item => item.typeCode == code);
                if (data && data.length > 0) {
                    return data[0].name
                }
            }
            return code;
        },

        //頁面事件
        handleTableChange(pagination, filters, sorter) {
            this.pagination.current = pagination.current;
            this.onPageLoad(true);
        },
        //搜尋表單提交
        handleSearchSubmit(e) {
            e.preventDefault();
            this.onPageLoad(true);
        },
        //狀態更新
        async handleOnEditState(item, status) {
            //edit state
            try {
                const res = await venues_changeState(item.id, status);
                if (res.code == 0) {
                    this.onPageLoad(true);
                } else {
                    this.$message.error(res.msg);
                }
            } catch (error) {
                this.$message.error(error.message);
            }
        },
        //刪除行
        async handleOnDelete(item) {
            try {
                const res = await destroy(item.id);
                if (res.code == 0) {
                    this.onPageLoad(true);
                } else {
                    this.$message.error(res.msg);
                }
            } catch (error) {
                console.log('delete error', error);
            }
        },
        handleToDetails(id) {
            this.$router.push(`/gymnasium/${id}`);
        },
        handleToForm(id) {
            if (id > 0) {
                this.$router.push(`/ad/edit/${id}`);
            } else {
                this.$router.push('/ad/add');
            }

        }
    }
}
